import { render, staticRenderFns } from "./WorkflowHeader.vue?vue&type=template&id=5b4a354b&scoped=true&lang=html&"
import script from "./WorkflowHeader.vue?vue&type=script&lang=js&"
export * from "./WorkflowHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowHeader.vue?vue&type=style&index=0&id=5b4a354b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a354b",
  null
  
)

export default component.exports